<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-list [ttData]="settings" [ttButtons]="rowButtons" [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="usergroupsetting_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" [ttHeading]="page.setting_name">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>

                    <tt-list class="col-xs-12 p-5" [ttData]="settings" [ttButtons]="rowButtons" [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-usergroup-setting-edit *ngIf="tablet.matches" [hidden]="selectedId === ''" class="col-xs-12 p-5" [itemId]="selectedId" (onSave)="updateList()"></tt-usergroup-setting-edit>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!page">
        <tt-input *ngIf="page.video_url > ''" ttLabel="video_url" [ttModel]="page.video_url" ttReadonly>
            <ng-container buttons><tt-form-field-button ttIcon="fas fa-window-restore" (ttClick)="openVideo()"></tt-form-field-button></ng-container>
        </tt-input>

        <tt-button *ngIf="showEnable" ttText="usergroupsetting_enable_all" ttType="success" ttIcon="far fa-check-square" ttTextAlign="center" [ttLoading]="enabling" (ttClick)="enableAll()"></tt-button>
        <tt-button *ngIf="showDisable" ttText="usergroupsetting_disable_all" ttType="danger" ttIcon="far fa-square" ttTextAlign="center" [ttLoading]="disabling" (ttClick)="disableAll()"></tt-button>
    </ng-container>
</ng-template>
